export const progressStepperData = {
    name: 'progress-stepper',
    tag: 'chameleon-progress-stepper',
    reactImports: 'ProgressStepper',
};
